import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/transitional/components/View';
import { BankIcon } from 'foundations-assets/icons/components/BankIcon';
import { CreditCardIcon } from 'foundations-assets/icons/components/CreditCardIcon';
import { DownIcon } from 'foundations-assets/icons/components/DownIcon';
import { SprocketIcon } from 'foundations-assets/icons/components/SprocketIcon';
import LinkWrapper from 'pricing-pages-ui-components/components/LinkWrapper';
import { getKBPaymentsUrl } from '../../../utils/publicKbUrls';
import { CardBody, CardShell, HubSpotHeaderTitle, MobileCardHeader, PaymentMethodsGrid, RecommendedBadge, SectionDivider } from '../NewPublicPaymentOptionsSectionStyles';
import { CheckItem, FeeRow, PaymentMethodBadge, TransactionFeesSectionHeader } from './shared';
import { AFFIRM_ICON_URL, APPLE_PAY_ICON_URL, GOOGLE_PAY_ICON_URL, KLARNA_ICON_URL } from './constants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const HubSpotCardHeader = ({
  isRecommended = false
}) => /*#__PURE__*/_jsxs(Flex, {
  alignItems: "center",
  gap: "200",
  flexWrap: "wrap",
  children: [/*#__PURE__*/_jsx(SprocketIcon, {
    color: "fill-accent-orange-default",
    size: "500"
  }), /*#__PURE__*/_jsx(HubSpotHeaderTitle, {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "payment-options-new.hubspot.name"
    })
  }), isRecommended && /*#__PURE__*/_jsx(RecommendedBadge, {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "payment-options-new.hubspot.recommendedBadge"
    })
  })]
});
export const HubSpotCardCTA = ({
  onEnrollClick
}) => /*#__PURE__*/_jsx(Button, {
  use: "primary",
  block: true,
  onClick: onEnrollClick,
  children: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "payment-options-new.hubspot.enrollInCard"
  })
});
export const HubSpotValueProps = () => /*#__PURE__*/_jsxs(Flex, {
  flexDirection: "column",
  gap: "200",
  marginBlockStart: "100",
  children: [/*#__PURE__*/_jsx(CheckItem, {
    iconColor: "fill-accent-orange-default",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "payment-options-new.hubspot.valueProps.1"
    })
  }), /*#__PURE__*/_jsx(CheckItem, {
    iconColor: "fill-accent-orange-default",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "payment-options-new.hubspot.valueProps.2"
    })
  }), /*#__PURE__*/_jsx(CheckItem, {
    iconColor: "fill-accent-orange-default",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "payment-options-new.hubspot.valueProps.3"
    })
  })]
});
function getPlatformFeeDescription(countryCode) {
  if (countryCode === 'GB') {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "payment-options-new.hubspot.transactionFees.platformFee.descriptionGB"
    });
  }
  if (countryCode === 'CA') {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "payment-options-new.hubspot.transactionFees.platformFee.descriptionCA"
    });
  }
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: "payment-options-new.hubspot.transactionFees.platformFee.description"
  });
}
export const HubSpotTransactionFees = ({
  countryCode
}) => /*#__PURE__*/_jsxs("div", {
  children: [/*#__PURE__*/_jsx(TransactionFeesSectionHeader, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "payment-options-new.hubspot.transactionFees.title"
    })
  }), /*#__PURE__*/_jsx(FeeRow, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "payment-options-new.hubspot.transactionFees.platformFee.label"
    }),
    value: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "payment-options-new.hubspot.transactionFees.platformFee.value"
    }),
    description: getPlatformFeeDescription(countryCode),
    comparison: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(DownIcon, {
        size: "300",
        color: "fill-positive-default"
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "payment-options-new.hubspot.transactionFees.platformFee.comparison"
      })]
    })
  }), /*#__PURE__*/_jsx(FeeRow, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "payment-options-new.hubspot.transactionFees.creditDebit.label"
    }),
    value: countryCode === 'GB' ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: "payment-options-new.hubspot.transactionFees.creditDebit.valueGB"
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "payment-options-new.hubspot.transactionFees.creditDebit.value"
    }),
    description: countryCode === 'GB' ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: "payment-options-new.hubspot.transactionFees.creditDebit.descriptionGB"
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "payment-options-new.hubspot.transactionFees.creditDebit.description"
    })
  }), countryCode === 'GB' ? /*#__PURE__*/_jsx(FeeRow, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "payment-options-new.hubspot.transactionFees.bacs.label"
    }),
    value: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "payment-options-new.hubspot.transactionFees.bacs.value"
    }),
    description: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "payment-options-new.hubspot.transactionFees.bacs.description"
    })
  }) : /*#__PURE__*/_jsx(FeeRow, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "payment-options-new.hubspot.transactionFees.ach.label"
    }),
    value: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "payment-options-new.hubspot.transactionFees.ach.value"
    }),
    description: countryCode === 'CA' ? /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "payment-options-new.hubspot.transactionFees.ach.descriptionCA_jsx",
      elements: {
        Bold: 'strong'
      }
    }) : /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "payment-options-new.hubspot.transactionFees.ach.description_jsx",
      elements: {
        Bold: 'strong'
      }
    })
  }), countryCode === 'CA' && /*#__PURE__*/_jsx(FeeRow, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "payment-options-new.hubspot.transactionFees.pads.label"
    }),
    value: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "payment-options-new.hubspot.transactionFees.pads.value"
    }),
    description: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "payment-options-new.hubspot.transactionFees.pads.description"
    })
  }), countryCode === 'GB' && /*#__PURE__*/_jsx(FeeRow, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "payment-options-new.hubspot.transactionFees.sepa.label"
    }),
    value: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "payment-options-new.hubspot.transactionFees.sepa.value"
    }),
    description: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "payment-options-new.hubspot.transactionFees.sepa.description"
    })
  }), /*#__PURE__*/_jsx(FeeRow, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "payment-options-new.hubspot.transactionFees.bnpl.label"
    }),
    value: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "payment-options-new.hubspot.transactionFees.bnpl.value"
    }),
    description: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "payment-options-new.hubspot.transactionFees.bnpl.description"
    })
  })]
});
export const HubSpotAdditionalFees = () => /*#__PURE__*/_jsxs("div", {
  children: [/*#__PURE__*/_jsx(Text, {
    as: "strong",
    typography: "heading-50",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "payment-options-new.hubspot.additionalFees.title"
    })
  }), /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    gap: "200",
    marginBlockStart: "200",
    children: [/*#__PURE__*/_jsx(CheckItem, {
      iconColor: "fill-accent-orange-default",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "payment-options-new.hubspot.additionalFees.fraud"
      })
    }), /*#__PURE__*/_jsx(CheckItem, {
      iconColor: "fill-accent-orange-default",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "payment-options-new.hubspot.additionalFees.storedCards"
      })
    }), /*#__PURE__*/_jsx(CheckItem, {
      iconColor: "fill-accent-orange-default",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "payment-options-new.hubspot.additionalFees.bankLinking"
      })
    })]
  })]
});
export const HubSpotPaymentMethodsSection = () => /*#__PURE__*/_jsxs("div", {
  children: [/*#__PURE__*/_jsx(Text, {
    as: "strong",
    typography: "heading-50",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "payment-options-new.hubspot.paymentMethods.title"
    })
  }), /*#__PURE__*/_jsxs(PaymentMethodsGrid, {
    children: [/*#__PURE__*/_jsx(PaymentMethodBadge, {
      icon: /*#__PURE__*/_jsx(CreditCardIcon, {}),
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "payment-options-new.hubspot.paymentMethods.creditDebit"
      })
    }), /*#__PURE__*/_jsx(PaymentMethodBadge, {
      icon: /*#__PURE__*/_jsx("img", {
        src: APPLE_PAY_ICON_URL,
        alt: "",
        height: 12,
        style: {
          display: 'block'
        }
      }),
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "payment-options-new.hubspot.paymentMethods.applePay"
      })
    }), /*#__PURE__*/_jsx(PaymentMethodBadge, {
      icon: /*#__PURE__*/_jsx("img", {
        src: GOOGLE_PAY_ICON_URL,
        alt: "",
        height: 12,
        style: {
          display: 'block'
        }
      }),
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "payment-options-new.hubspot.paymentMethods.googlePay"
      })
    }), /*#__PURE__*/_jsx(PaymentMethodBadge, {
      icon: /*#__PURE__*/_jsx("img", {
        src: KLARNA_ICON_URL,
        alt: "",
        height: 12,
        style: {
          display: 'block'
        }
      }),
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "payment-options-new.hubspot.paymentMethods.klarna"
      })
    }), /*#__PURE__*/_jsx(PaymentMethodBadge, {
      icon: /*#__PURE__*/_jsx("img", {
        src: AFFIRM_ICON_URL,
        alt: "",
        height: 12,
        style: {
          display: 'block'
        }
      }),
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "payment-options-new.hubspot.paymentMethods.affirm"
      })
    }), /*#__PURE__*/_jsx(PaymentMethodBadge, {
      icon: /*#__PURE__*/_jsx(BankIcon, {}),
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "payment-options-new.hubspot.paymentMethods.ach"
      })
    }), /*#__PURE__*/_jsx(PaymentMethodBadge, {
      icon: /*#__PURE__*/_jsx(BankIcon, {}),
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "payment-options-new.hubspot.paymentMethods.pads"
      })
    }), /*#__PURE__*/_jsx(PaymentMethodBadge, {
      icon: /*#__PURE__*/_jsx(BankIcon, {}),
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "payment-options-new.hubspot.paymentMethods.sepa"
      })
    })]
  })]
});
export const HubSpotCardFooter = () => /*#__PURE__*/_jsxs(Flex, {
  flexDirection: "column",
  gap: "300",
  children: [/*#__PURE__*/_jsx(Text, {
    typography: "body-100",
    color: "text-secondary-default",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "payment-options-new.hubspot.availability"
    })
  }), /*#__PURE__*/_jsxs(Text, {
    typography: "body-100",
    color: "text-secondary-default",
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "payment-options-new.hubspot.footer.highVolumeText"
    }), ' ', /*#__PURE__*/_jsx(LinkWrapper, {
      href: "mailto:revenuehubteam@hubspot.com",
      external: true,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "payment-options-new.hubspot.footer.contactTeamLink"
      })
    }), ' ', /*#__PURE__*/_jsx(FormattedMessage, {
      message: "payment-options-new.hubspot.footer.learnMoreSuffix"
    })]
  }), /*#__PURE__*/_jsx(View, {
    children: /*#__PURE__*/_jsx(LinkWrapper, {
      href: getKBPaymentsUrl('#rates-fees'),
      external: true,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "payment-options-new.hubspot.footer.learnMoreLink"
      })
    })
  })]
});
export const HubSpotPaymentCard = ({
  onEnrollClick,
  countryCode,
  isRecommended = false
}) => /*#__PURE__*/_jsxs(CardShell, {
  isHighlighted: isRecommended,
  children: [/*#__PURE__*/_jsx(MobileCardHeader, {
    isHighlighted: isRecommended,
    children: /*#__PURE__*/_jsx(HubSpotCardHeader, {
      isRecommended: isRecommended
    })
  }), /*#__PURE__*/_jsxs(CardBody, {
    children: [/*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      gap: "300",
      children: [/*#__PURE__*/_jsx(HubSpotValueProps, {}), /*#__PURE__*/_jsx(HubSpotCardCTA, {
        onEnrollClick: onEnrollClick
      })]
    }), /*#__PURE__*/_jsx(SectionDivider, {}), /*#__PURE__*/_jsx(HubSpotTransactionFees, {
      countryCode: countryCode
    }), /*#__PURE__*/_jsx(HubSpotAdditionalFees, {}), /*#__PURE__*/_jsx(SectionDivider, {}), /*#__PURE__*/_jsx(HubSpotPaymentMethodsSection, {}), /*#__PURE__*/_jsx(SectionDivider, {}), /*#__PURE__*/_jsx(HubSpotCardFooter, {})]
  })]
});